import React from "react";
import DirectorateClassicPage from "../../components/institutional/DirectorateClassicPage";
import { directorateItsPage } from "../../data/institutionalPageData";

export default function DirectorateofIts() {
  return <DirectorateClassicPage data={directorateItsPage} />;
}
